import classNames, { Argument } from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks';
import { Button, Help, Icon, LanguageSelect } from 'components/ui';
import { isDevelopment } from 'utils/appUtils';
import { ButtonType } from 'components/ui/Button';
import { getKioskId } from 'modules/dealers/selectors';
import { useCheckQRCodeTokenMutation } from 'modules/auth/service';
import { isOffline as isOfflineSelector } from 'modules/healthCheck/selectors';

interface HeaderProps {
  className?: Argument;
}

const Header: React.FC<HeaderProps> = ({ className }) => {
  const kioskId = useSelector(getKioskId);
  const isOffline = useSelector(isOfflineSelector);

  const [login] = useCheckQRCodeTokenMutation();

  const handlePrompt = () => {
    const qrCodeToken = prompt('Please enter your QRCode token:');
    login({ qrCodeToken, kioskId });
  };

  return (
    <div className="relative flex justify-between items-center w-full">
      {isOffline && (
        <div className="absolute top-0 inset-x-0 z-30 flex justify-center items-center py-10 px-24 kiosk:px-36">
          <div
            className="rounded-button text-center text-default bg-overlay py-5 pl-5 pr-10 text-2xl font-bold flex items-center"
          >
            <div className="rounded-full size-10 bg-warning-default relative flex justify-center items-center mr-5">
              <Icon className="fb-icon--no-wifi text-xl kiosk:text-3xl aspect-square text-white" />
            </div>
            <FormattedMessage id="offline.feedback" defaultMessage="No internet connection" />
          </div>
        </div>
      )}
      <div className={classNames('z-40 px-7 kiosk:px-12', className)}>
        <Help />
      </div>
      <div className={classNames('flex justify-end w-full z-40 px-7 kiosk:px-12', className)}>
        {isDevelopment && (
          <div className="py-3 kiosk:py-10 z-50 mr-4">
            <Button
              type={ButtonType.SECONDARY}
              onClick={handlePrompt}
              className="size-10 kiosk:size-20 !p-2 flex items-center justify-center btn-header"
            >
              <div className="absolute -top-3 -left-3">
                <span className="absolute block px-2 kiosk:px-4 bg-danger-default rounded-full -rotate-30 origin-center-right text-white !text-xs kiosk:!text-lg">dev</span>
              </div>
              <Icon className="fb-icon--configuration text-2xl kiosk:text-4xl block" />
            </Button>
          </div>
        )}
        <LanguageSelect />
      </div>
    </div>
  );
};

export default Header;
